import React, { useState } from 'react';
import { connect } from 'react-redux'
import _ from 'lodash';
import moment from 'moment';
import { setReviewAssigInfo, addReviewAssign } from './actions';
import { 
  addReviewAssignPost, updateOutputGroupDueDate, updateDocGroupDueDate, 
  sendOutputInviteEmail, sendDocInviteEmail } from './thunks';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import ReviewAssignTable from './ReviewAssignTable';
import { getMomentDate } from './util';
import 'react-datepicker/dist/react-datepicker.css';
import './ReviewAssignModal.css';

const ReviewAssignModal = ({ 
  users = [], userInfo, groupInfo, reviewInfo, reviewAssignInfo = {}, 
  startSetReviewAssignInfo, startAddReviewAssign, startAddReviewAssignPost,
  startSendOutputInviteEmail, startSendDocInviteEmail, 
  startUpdateDocGroupDueDate, startUpdateOutputGroupDueDate }) => {
  
  const [reviewTitle, setReviewTitle] = useState(' ');
  let userSelected = '';
  
  const handleClose = () => startSetReviewAssignInfo({ show:false });
  
  const sendEmail = () => {
    // console.log('>>> ReviewAssignModal sendEmail');
    const title = document.getElementById('formTitle').value;
    const content = document.getElementById('formMessage').value;
    const selectedReviewers = _.filter(
      reviewAssignInfo.reviewers, 
      (reviewAssign) => reviewAssign.selected);
    // console.log('--> selectedReviewers:', selectedReviewers);
    if (reviewInfo.type === 'output') {
      startSendOutputInviteEmail({ 
        emailData: {title, content}, 
        reviewInfo: reviewInfo,
        groupInfo: groupInfo,
        reviewers:selectedReviewers 
      });
    } else if (reviewInfo.type === 'doc') {
      startSendDocInviteEmail({ 
        emailData: {title, content}, 
        reviewInfo: reviewInfo,
        groupInfo: groupInfo,
        reviewers:selectedReviewers 
      });
    }
    startSetReviewAssignInfo({ show:false });
  };
  
  const getDefaultReviewTitle = () => {
    let result = '';
    let milestone = `${reviewInfo.milestone}`;
    if (milestone === 'undefined') {
      milestone = '';
    }
    if (reviewInfo.type === 'output') {
      result += `${reviewInfo.user} invites you to review the outputs ` + 
      `from ${reviewInfo.program} ${reviewInfo.study} ${milestone}`;
    } else if (reviewInfo.type === 'doc') {
      result += `${reviewInfo.user} invites you to review the documents ` + 
      `from ${reviewInfo.program} ${reviewInfo.study} ${milestone}`;
    }
    return result;
  }
  
  const setDueDate = (date) => {
    const data = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      dueDate: moment(date).format('YYYY-MM-DD'),
    };
    if (reviewInfo.type === 'output') {
      startUpdateOutputGroupDueDate(data);
    } else if (reviewInfo.type === 'doc') {
      startUpdateDocGroupDueDate(data);
    }
  };
  
  const content = (
    <Modal show={ reviewAssignInfo.show } onHide={handleClose}>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={6}><b>Review Invitation</b></Col>
            <Col md={6}> Due Date 
              <DatePicker selected={getMomentDate(groupInfo.dueDate)} onChange={date => setDueDate(date)} />
            </Col>
          </Row>
          <hr/>
          <Form>
            <Form.Group controlId="formTitle">
              <Form.Label>Review Title</Form.Label>
              <Form.Control type="text" 
                value={reviewTitle === ' ' ? getDefaultReviewTitle():reviewTitle} 
                onChange={(event) => setReviewTitle(event.target.value)} />
            </Form.Group>
            <Form.Group controlId="formMessage">
              <Form.Label>Message to Reviewers</Form.Label>
              <Form.Control as="textarea" rows="2" />
            </Form.Group>
            <Row>
              <Col md={10}>
                <Form.Group controlId="userSelectControl">
                  <Select id="userSelectDropdown" options={ users.map((user, index) => (
                    { label:user, value:user }
                  )) } onChange={ opt => userSelected = opt.value } />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Button className="btn-bps" variant="light" onClick={()=>{ 
                  if (!userSelected) { return }
                  console.log('add selected user:', userSelected);
                  startAddReviewAssign(userSelected);
                  // data: milestoneId, groupId, assignUserId, createUserId
                  let addReviewData = { 
                    milestoneId: reviewInfo.milestoneId, 
                    groupId: reviewInfo.groupId, 
                    assignUserId: userSelected, 
                    createUserId: reviewInfo.user
                  };
                  console.log('addReviewData:', addReviewData);
                  startAddReviewAssignPost(addReviewData);
                }}>Add</Button>
              </Col>
            </Row>
            <ReviewAssignTable />
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-bps" variant="light" onClick={sendEmail}>
          Send Review Invitation
        </Button>
        <Button className="btn-bps" variant="light" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
  return content;
}

const mapState = state => ({
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
  users: state.users,
})

const mapDispatch = dispatch => ({
  startSetReviewAssignInfo: (data) => dispatch(setReviewAssigInfo(data)),
  startAddReviewAssign: (userId) => dispatch(addReviewAssign(userId)),
  startAddReviewAssignPost: (data) => dispatch(addReviewAssignPost(data)),
  startSendOutputInviteEmail: (data) => dispatch(sendOutputInviteEmail(data)),
  startSendDocInviteEmail: (data) => dispatch(sendDocInviteEmail(data)),
  startUpdateOutputGroupDueDate: (data) => dispatch(updateOutputGroupDueDate(data)),
  startUpdateDocGroupDueDate: (data) => dispatch(updateDocGroupDueDate(data)),
})

export default connect(mapState, mapDispatch)(ReviewAssignModal);
